import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyDatasetsServices = {
  //Datasets
  storeAllDataEntryDatasets,
  storeAllDataEntryDatasetsByNameLabel,
  getAllDataEntryDatasets,
  getAllDataEntryDatasetsByNameLabel,
  getAllDataEntryDatasetByColumn,

  //Datset Transfer
  addNewDatasetTransfer,
  updateStudyDatasetTransfer,
  deleteStudyAIDatasetTransferData,
  getStudyDataTransfered,
  getSingleDataTransferedInfo,
  sharedLogin,
  getSharedDataset,
  getStudyOnDemandTransferedHistory,
  getStudyDatasetTransferedHistory
};

// Store Datasets
async function storeAllDataEntryDatasets(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}storeAllDataEntryDatasets`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Store Datasets By Name Label
async function storeAllDataEntryDatasetsByNameLabel(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}storeAllDataEntryDatasetsByNameLabel`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Datasets
async function getAllDataEntryDatasets(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAllDataEntryDatasets`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Datasets
async function getAllDataEntryDatasetsByNameLabel(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAllDataEntryDatasetsByNameLabel`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Event Schema
async function getAllDataEntryDatasetByColumn(studyId, formId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAllDataEntryDatasetByColumn/${studyId}/${formId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Add New Study Dataset Transfer
async function addNewDatasetTransfer(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewDatasetTransfer`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Dataset Transfer
async function updateStudyDatasetTransfer(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyDatasetTransfer`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Study Dataset Transfer
async function deleteStudyAIDatasetTransferData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyAIDatasetTransferData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Dataset Transfer
async function getStudyDataTransfered(status, studyId, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDataTransfered/${status}/${studyId}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDataTransfered/${status}/${studyId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Single Study Dataset Transfer Info
async function getSingleDataTransferedInfo(studyId, transferId, type) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSingleDataTransferedInfo/${studyId}/${transferId}/${type}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Shared login
async function sharedLogin(email, password, studyId, transferId) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password, studyId, transferId }),
  };

  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}sharedLogin`,
    requestOptions
  );

  const data = await response.json();
  handleResponse(data);

  let loginType = data?.loginType || "";
  let studyUniqueId = data?.studyId || "";
  let timer = data?.timer || "";
  let transferUniqueId = data?.transferId || "";
  let studyMode = data?.studyMode || "";
  if (data.statusCode === 200) {
    localStorage.setItem("loginType", JSON.stringify(loginType));
    localStorage.setItem("studyId", JSON.stringify(studyUniqueId));
    localStorage.setItem("studyMode", JSON.stringify(studyMode));
    localStorage.setItem("timer", JSON.stringify(timer));
    localStorage.setItem("transferId", JSON.stringify(transferUniqueId));
    localStorage.setItem("token", JSON.stringify(data.token));
    window.location.href = "/sharedData";
  }
  return data;
}

// Get Shared Dataset
async function getSharedDataset(studyId, transferId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSharedDataset/${studyId}/${transferId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Ondemand Transfer History
async function getStudyOnDemandTransferedHistory(studyId, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyOnDemandTransferedHistory/${studyId}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyOnDemandTransferedHistory/${studyId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study Dataset Transfer History
async function getStudyDatasetTransferedHistory(studyId, transferId, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDatasetTransferedHistory/${studyId}/${transferId}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDatasetTransferedHistory/${studyId}/${transferId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}